module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "8",
      "height": "8",
      "viewBox": "0 0 8 8",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "4",
      "cy": "4",
      "r": "4",
      "fill": "#004A98"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40f6cbdb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/BlueDot.vue
// module id = 1486
// module chunks = 159